
const keyFormatter = (key: string): string => key.replace(/ /g, '_').toUpperCase();

const mapEnum = <T extends string>(
    enums: T[],
    formatter: (key: T) => string = keyFormatter
): Record<string, T> => {
    const mappedObj: Record<string, T> = {};
    enums.forEach((enumValue) => {
        mappedObj[formatter(enumValue)] = enumValue;
    });
    return mappedObj;
};

const convertToTime = (input: string | undefined) => {
    const inputNumber = input ? parseInt(input, 10) : parseInt('', 10);
    const hours = Math.floor(inputNumber / 100);
    const minutes = inputNumber % 100;
    const meridiem = hours < 12 ? 'AM' : 'PM';

    const formattedHours = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes} ${meridiem}`;
};

const hexToRgba = (hex: string, alpha: number) => {
    const bigint = parseInt(hex.slice(1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export { mapEnum, convertToTime, hexToRgba }
